export default __webpack_public_path__ + "static/media/discipline-it.56538516.svg";